import { MIMETYPE_XLSX } from '@disy/lib/media-type';

import type { IndividualValuesTableDataExportOptions } from 'cadenza/api-client/workbook-export-data-api';
import type { WorkbookNameAndHash } from 'cadenza/repository/model/workbook-name-and-hash';
import type { ViewId } from 'cadenza/workbook/api/view-id';
import { AbstractIndividualValuesDrillThroughExportAction } from 'cadenza/workbook/individual-values-table-dialog/abstract-individual-values-drill-through-export-action';

import i18n from './individual-values-table-dialog.properties';

export class ExportIndividualValuesDrillThroughToXlsxAction extends AbstractIndividualValuesDrillThroughExportAction {
  constructor(
    workbookNameAndHash: WorkbookNameAndHash,
    viewId: ViewId,
    downloadParamsProvider: () => IndividualValuesTableDataExportOptions,
  ) {
    super(workbookNameAndHash, viewId, downloadParamsProvider, MIMETYPE_XLSX, {
      label: i18n('action.label.xlsx'),
      dialogTitle: i18n('dialog.title.xlsx'),
    });
  }

  override get enabledSync() {
    return true;
  }
}
